import React, { Component } from 'react';
import { Form, Input, Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';

class LargeProjectOrderEntry_measurements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionValue: ''
        }
    }

    
    handleTextInputChange = (e) => {
        console.log("mx1 >>>>: handleTextInputChange ");
        console.log("mx33 e.target.type:" + e.target.type);
        console.log("mx32 e.target.name:" + e.target.name);
        console.log("mx34 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

        this.props.handleTextInputChange(e);

    }


    render() {

        return (
            <div>
                <Label pointing='below' color='blue'>{this.props.measurement.measurement_name}</Label>
                <Form.Input
                        fluid
                        icon='person'
                        iconPosition='left'
                        placeholder={this.props.measurement.measurement_name}
                        type='number'
                        name={this.props.measurement.measurement_name}
                        onChange={this.handleTextInputChange}
                    />
            </div>);
    }
}

export default LargeProjectOrderEntry_measurements;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry_measurements.js